import { render, staticRenderFns } from "./InvoiceView.vue?vue&type=template&id=0dd20f9d&scoped=true&"
import script from "./InvoiceView.vue?vue&type=script&lang=js&"
export * from "./InvoiceView.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceView.vue?vue&type=style&index=0&id=0dd20f9d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd20f9d",
  null
  
)

export default component.exports